import {
  get,
  set,
  isNil,
  isEmpty,
  isFunction,
  head,
  startsWith,
  clone,
  cloneDeep,
} from 'lodash';
import classNames from 'classnames/dedupe';

const isEditableColumn = (column, record) => {
  let colEditable = false;
  if (typeof column.editable === 'function') colEditable = !!column.editable(record, column.key);
  else colEditable = !!column.editable;
  return colEditable && record.editable !== false;
};

const makeTotalRow = (total, { dataIndex }) =>
  Object.assign(total, set({}, dataIndex, get(total, dataIndex, 'Total')), {
    className: classNames('total-row', total.className),
    editable: !!total.editable,
  });

const makeColumn = props => (column, i) => {
  const col = { ...column };
  if (!isEmpty(col.children)) col.children = col.children.map(child => makeColumn(props)(child));
  else if (isNil(col.dataIndex)) col.dataIndex = col.key;
  // props set on the Cell component
  col.onCell = record => {
    const cellProps = {
      ...props,
      columnKey: col.key,
      dataIndex: col.dataIndex,
      displayPrice: !!col.displayPrice,
      expandable: i === 0, // first column will be expandable if record has children
      recordKey: record.key,
      value: isNil(record[col.key]) ? null : record[col.key], // no value will render nothing
      editable: isEditableColumn(col, record),
      hasRenderColumn: typeof col.render === 'function',
      hasRenderRecord: isFunction(record.render) || isFunction(get(record.render, col.key)),
      className: get(record.columnsClassNames, col.key),
    };
    if (cellProps.editable) {
      if (isNil(col.input)) cellProps.input = 'text';
      else if (typeof col.input === 'object') cellProps.input = clone(col.input);
      else cellProps.input = col.input;
    }
    /**
     * Render on record
     * * function({ columnKey, recordKey, value, defaultRender })
     * * object { columnKey: function({ columnKey, recordKey, value, defaultRender }) }
     */
    if (cellProps.hasRenderRecord) {
      if (isFunction(record.render)) cellProps.renderRecord = record.render;
      else if (isFunction(get(record.render, col.key))) cellProps.renderRecord = record.render[col.key];
    }
    return { cellProps };
  };
  return col;
};

export const makeColumns = (columns, props) => columns.map(makeColumn(props));

export const makeDataSource = (dataSource, columns) => {
  const ds = cloneDeep(dataSource);
  ds.forEach(record => {
    if (!startsWith(record.key, 'total')) return;
    makeTotalRow(record, head(columns));
  });
  return ds;
};

export const sanitizeFloatNumber = val => {
  if (!val.includes('.')) return val;
  const dotIndex = val.indexOf('.');
  return val.slice(0, dotIndex + 3);
};
